<template>
  <div>
    <div class="point-share" :class="{ 'active': isVisible }" v-body-scroll-lock="isVisible">
      <div class="containter">
        <div class="row justify-content-center">
          <div class="col col-12 col-md-6 col-lg-4">
            <div class="point-share__container">
              <div class="content">
                <form class="form" action="#" v-on:submit.prevent="handleSubmit">
                  <div class="row no-gutters">
                    <div class="col-5 cell-country__container">
                      <country-select
                        class="cell-country"
                        v-on:select-country="handleCountrySelect"
                        :defaultCountry="defaultCountry"
                      ></country-select>
                    </div>
                    <div class="col-7">
                      <input
                        type="tel"
                        class="cell"
                        :placeholder="$t('entry.common:mobileNumber')"
                        v-model="cellNumber"
                        @blur="handleCellBlur"
                      />
                    </div>
                  </div>
                  <div class="row no-gutters align-items-center form-error" v-if="phoneError">
                    <i class="material-icons icon">error</i>
                    <div class="text">{{ phoneError }}</div>
                  </div>
                  <div class="row no-gutters">
                    <div class="col-12">
                      <input
                        type="number"
                        class="amount"
                        min="0"
                        :max="maxAmount"
                        :placeholder="$t('points.transferAmount')"
                        v-model="amount"
                      />
                    </div>
                  </div>
                  <div class="row no-gutters" v-if="member">
                    <div class="col-12">
                      <div
                        class="option"
                        :class="{ 'is-picked': isOptionPicked }"
                        v-on:click="pickOption()"
                      >
                        <div class="option__check">
                          <i class="material-icons">check</i>
                        </div>
                        <div class="option__label">
                          {{ $t('points.iAgreeToTransferDescription', { name: member }) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row narrow-gutters">
                    <div class="col-auto">
                      <button
                        class="btn btn-lg btn-block"
                        v-on:click.prevent="handleCancel"
                      >{{ $t('common.cancel') }}</button>
                    </div>
                    <div class="col">
                      <button
                        class="btn btn-lg btn-block"
                        :class="{ 'btn-loading': isLoading }"
                        :disabled="isFormDisabled"
                        type="submit"
                      >
                        {{ $t('common.submit') }}
                        <div class="btn-loader"><span></span><span></span><span></span></div>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="point-share-overlay" v-if="isVisible" @click="handleCancel"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AwesomePhonenumber from 'awesome-phonenumber';
import swal from 'sweetalert2';
import Axios from '@/helpers/axios';
import CountrySelect from '@/components/Entry/Country-Select.vue';

export default {
  name: 'PointTransferModal',
  components: {
    CountrySelect,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    maxAmount: {
      type: Number,
      required: true,
    },
    defaultCountry: {
      type: String,
      default: 'TW',
    },
  },
  data() {
    return {
      cellNumber: '',
      selectedCountry: this.defaultCountry,
      amount: null,
      isLoading: false,
      phoneError: '',
      isCheckingMember: true,
      member: '',
      isOptionPicked: false,
    };
  },
  computed: {
    ...mapState([
      'client',
    ]),
    phoneInstance() {
      return new AwesomePhonenumber(
        this.cellNumber,
        this.selectedCountry,
      );
    },
    isPhoneValid() {
      return (
        this.phoneInstance.isValid() &&
        this.phoneInstance.isMobile()
      );
    },
    isFormDisabled() {
      return (
        this.isLoading ||
        this.isCheckingMember ||
        !this.amount ||
        !!this.phoneError ||
        !this.isOptionPicked
      );
    },
  },
  methods: {
    handleCountrySelect(value) {
      this.selectedCountry = value;
    },
    handleCancel() {
      this.resetForm();
      this.$emit('cancel');
    },
    async handleCellBlur() {
      this.phoneError = '';

      // 手機變更時，重置收贈人資訊與勾選狀態
      this.member = '';
      this.isOptionPicked = false;
      this.isCheckingMember = true;

      if (!this.cellNumber) {
        return;
      }

      if (!this.isPhoneValid) {
        this.phoneError = this.$i18n.t('common.mobileNumberIncorrect');
        return;
      }

      const data = {
        p: this.client.phoneType,
        cell: this.phoneInstance.getNumber('significant'),
        country_code: AwesomePhonenumber.getCountryCodeForRegionCode(this.phoneInstance.getRegionCode()),
        lang: this.$i18n.locale,
        brand_id: this.$route.params.brand,
      };

      try {
        const response = await Axios({
          method: 'post',
          url: '/v2/Ocard/getTransferUser',
          data,
        });

        const { code, msg } = response.data;

        if (code === 500) {
          this.isCheckingMember = false;
          this.phoneError = '';
          this.member = response.data.data.name;
          return;
        }

        if (code === 496) {
          this.phoneError = this.$i18n.t('points.recipientNotVip');
          this.member = '';
          return;
        }

        if (code === 495) {
          this.phoneError = '';
          this.member = '';
          if (msg) {
            swal.fire({
              text: msg,
              confirmButtonText: this.$i18n.t('common.ok'),
            });
          }
          return;
        }

        this.phoneError = '';
        this.member = '';
      } catch (e) {
        this.phoneError = '';
        this.member = '';
      }
    },
    pickOption() {
      if (!this.member || this.isCheckingMember || this.phoneError) {
        return;
      }
      this.isOptionPicked = !this.isOptionPicked;
    },
    handleSubmit() {
      if (this.phoneError) {
        return;
      }

      if (!this.isPhoneValid) {
        swal.fire({
          text: this.$i18n.t('common.mobileNumberIncorrect'),
          confirmButtonText: this.$i18n.t('common.ok'),
        });
        return;
      }

      if (this.amount > this.maxAmount) {
        swal.fire({
          text: this.$i18n.t('points.transferFailedNotEnoughDescription'),
          confirmButtonText: this.$i18n.t('common.ok'),
        });
        return;
      }

      this.isLoading = true;

      const data = {
        cell: this.phoneInstance.getNumber('significant'),
        country_code: AwesomePhonenumber.getCountryCodeForRegionCode(this.phoneInstance.getRegionCode()),
        point: this.amount,
        brand_id: this.$route.params.brand,
      };

      this.$emit('submit', data, this.handleSubmitComplete);
    },
    handleSubmitComplete(success = true) {
      this.isLoading = false;
      if (success) {
        this.resetForm();
      }
    },
    resetForm() {
      this.cellNumber = '';
      this.amount = null;
      this.selectedCountry = this.defaultCountry;
      this.phoneError = '';
      this.isCheckingMember = true;
      this.member = '';
      this.isOptionPicked = false;
    },
  },
  watch: {
    isVisible(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
$cb: cubic-bezier(.4, 0, .2, 1)

.point-share
  position: fixed
  top: 50%
  left: 50%
  width: 100%
  z-index: 1050
  opacity: 0

  transform: translate(-50%, -50%) scale(.75)
  transition: transform .25s $cb

  pointer-events: none

  &-overlay
    position: fixed
    right: 0
    bottom: 0
    left: 0
    top: 0
    z-index: 1040

    background-image: linear-gradient(0deg, rgba(44, 43, 43, 0.665) 0%, rgba(33, 32, 32, 0.665) 100%)

  &.active
    opacity: 1

    transform: translate(-50%, -50%)
    pointer-events: auto

  &__container
    overflow: hidden
    width: 100%

    border-radius: 16px

    background-color: #282828

    color: white

  .content
    padding: 24px 16px 16px

  &-text
    width: 100%
    padding: 16px

    border: none
    border-radius: 16px

    background-color: #333

    color: white

    &:focus
      outline: 0

  .form
    input[type=text],
    input[type=number],
    input[type=tel],
    input[type=password]
      width: 100%

      padding: 10px 15px

      border: none
      border-radius: 23px

      background-color: #eee

      font-weight: 700
      color: #333

      &:focus
        outline: none

    .readonly
      pointer-events: none

    .form-error
      margin-top: 10px
      font-size: 12px
      color: white
      .text
        margin-left: 4px

  .transfer
    text-align: center
    margin-bottom: 16px

    &-btn
      display: inline-block
      padding: 8px 16px

      border-radius: 6px

      background-color: #f5f5f5
      cursor: pointer

      color: #8E8E8E
      font-size: 12px
      font-weight: 500

  .form
    .cell-country
      width: 100%
      padding: 10px 15px
      overflow: hidden

      border: none
      border-radius: 23px

      background-color: #ffea00
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAwCAYAAACooNxlAAAABGdBTUEAALGPC/xhBQAAAYxJREFUaAXt1T9ugzAUBnAMQ5Zmh1vwZ2qToVvVC+Qulao26aWabjkBp4gEe3bo+9JYslCRYgPCSJ8lBwh5j+cfthMEbBSgAAUoQAEKUIACFKAABShAAQpQgAIUcBHIsuxd+qNLrBlTFMVW+pv53ZznkcvDZQBfSqm99F0cx6e6rs+OebZt235LntckSVRVVSeXPGPGWIPIrDjIAD5uRaxcUTAzbhgPyCV5nn1ACW11pfC2E7MOw/DHZvmkaboxMTr5Zr20niGY1niTeKNG5XfPFGAI4FHirzND5xCgQ1mWe30919EaBIW6ogAjiiLsGWtzwL5goCYnEATaomgMCfUWA+NyBkHwvSiC8SQz4yghXmNgTAofQ1ue5/gL/uzkuTRN8yLLQS0FA/WPAoJEfSi4J837mfFX5sAlo5Pg2Ld85NbK/J1PG6hZlz4ftIfoJPrYg6JvB75joNBRQZCwD2UJGJOA/IeyFAzUPmnDRos+6UOYnAIUoAAFKEABClCAAhSgAAUoQAEKUGCQwC/1HLKALR1EkwAAAABJRU5ErkJggg==')
      background-size: 24px
      background-repeat: no-repeat
      background-position: right center

      font-weight: 700
      color: #333

      -webkit-padding-end: 24px
      appearance: none
      text-overflow: ellipsis
      white-space: nowrap

      &__container
        height: 44px

        border-radius: 23px 0 0 23px

        background-color: #333

      &::after
        content: ''

      &:focus
        outline: none

    .cell[type=tel]
      border-radius: 0 23px 23px 0

      background-color: #333

      color: white

    .amount[type=number]
      border-radius: 23px
      background-color: #333
      color: white
      margin-top: 10px

    .icon
      font-size: 16px
      color: #FFEA00

  .btn
    position: relative
    margin-top: 24px
    padding: 8px 15px

    border-color: transparent
    border-radius: 99px

    background-color: #FFEA00

    font-size: 1.125em
    font-weight: 700
    color: #333

    outline: none
    appearance: none

    &:hover,
    &:active
      opacity: .5

      border-color: transparent

      background-color: #FFEA00

      color: #333

      outline: none

    &-secondary
      opacity: .5

    &.btn-loading
      pointer-events: none

      .btn-loader
        display: block

    .btn-loader
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      border-radius: 99px
      display: none

      background-color: inherit

      &.inverse
        span
          background-color: white

      span
        display: inline-block
        width: 10px
        height: 10px
        border-radius: 100%
        background-color: #575757
        margin: 18px 5px
        opacity: 0

        &:nth-child(1)
          animation: opacitychange .5s ease-in-out infinite

        &:nth-child(2)
          animation: opacitychange .5s ease-in-out .166666667s infinite

        &:nth-child(3)
          animation: opacitychange .5s ease-in-out .333333334s infinite

        @keyframes opacitychange
          0%, 100%
            opacity: 0

          60%
            opacity: 1
  .option
    display: flex
    align-items: center

    margin-top: 20px
    cursor: pointer

    &.is-picked
      .option__check
        background-color: #ffea00

    &__check
      display: flex
      align-items: center
      justify-content: center
      width: 32px
      height: 32px
      margin-right: 8px
      color: #282828

      border-radius: 50%

      background-color: rgba(255, 255, 255, .1)

      transition: background-color .1s cubic-bezier(.4, 0, .2, 1)

    &__check-svg
      display: block

    &__label
      flex-grow: 1

      font-size: 14px
      font-weight: bold

</style>
